import type { ModelingFormat, WorkspaceJSON, WorkspaceMemberRoleJSON } from 'balus-common';

export class WorkspaceSetting {
  constructor(
    readonly isPublicSpace: boolean,
    readonly isViewModelURLShareable: boolean,
    readonly enableIndividualViewModelPermissions: boolean,
    readonly modelingFormat: ModelingFormat
  ) {}

  dump(): WorkspaceJSON['setting'] {
    const { isPublicSpace, isViewModelURLShareable, enableIndividualViewModelPermissions, modelingFormat } = this;
    return {
      isPublicSpace,
      isViewModelURLShareable,
      enableIndividualViewModelPermissions,
      modelingFormat,
    };
  }

  static load(dump: WorkspaceJSON['setting']): WorkspaceSetting {
    const { isPublicSpace, isViewModelURLShareable, enableIndividualViewModelPermissions, modelingFormat } = dump;
    return new this(
      isPublicSpace,
      isViewModelURLShareable,
      enableIndividualViewModelPermissions || false,
      modelingFormat
    );
  }

  static buildDefault(
    groupIndividualViewModelPermission: boolean,
    modelingFormat: ModelingFormat = 'CJK'
  ): WorkspaceSetting {
    return this.load({
      isPublicSpace: false,
      isViewModelURLShareable: false,
      enableIndividualViewModelPermissions: groupIndividualViewModelPermission,
      modelingFormat,
    });
  }

  static buildForPersonalWorkspace(modelingFormat: ModelingFormat = 'CJK'): WorkspaceSetting {
    return this.load({
      isPublicSpace: false,
      isViewModelURLShareable: false,
      enableIndividualViewModelPermissions: true,
      modelingFormat,
    });
  }

  /**
   * 対象ワークスペース・エンティティの読み取り可否を返します。
   *
   * @param role 対象ワークスペースの所属ロール。非所属の場合には null を渡す。
   * @returns 対象のワークスペース・エンティティを読み取り可能な場合に true を返す
   */
  canReadEntity(role: WorkspaceMemberRoleJSON | null): boolean {
    const { isPublicSpace } = this;

    return role !== null || isPublicSpace;
  }
}
